import React, { createContext, FC, PropsWithChildren, useContext, useMemo } from 'react';
import { NavigationType } from '../types';
import { getNavPathFromType as _getNavPathFromType } from '../lib';
import { CMSCTA } from '../models';
import { WalletPoints } from '@jnext/ts-axios-wallet';

interface JCommonContextModel {
    navigate: (type: NavigationType, params?: CMSCTA['scopeParameters']) => void,
    getImageURL: (name: string) => string,
    setLoading: (value: boolean) => void,
    walletData: WalletPoints[]
}

export const JCommonContext = createContext<JCommonContextModel>({
    navigate: () => console.warn('MZ Navigation function not implemented'),
    getImageURL: (name: string) => {
        console.warn('Get Image URL function not implemented');
        return name
    },
    setLoading: () => {},
    walletData: []

})

interface JCommonProviderProps {
    mzNavigate: (path: NavigationType) => void,
    /**
     * Override getNavPathFromType common function
     *
     * @memberof JCommonProviderProps
     */
    getNavPathFromType?: (type: NavigationType, params?: Record<string, any>) => string,
    imagePathURL: any,
    setLoading: JCommonContextModel['setLoading'],
    walletData: JCommonContextModel['walletData']
}

export const JCommonProvider: FC<PropsWithChildren<JCommonProviderProps>> = (props) => {

    const getNavPathFromType = useMemo(() => {
        if (props.getNavPathFromType) props.getNavPathFromType
        return _getNavPathFromType
    }, [props.getNavPathFromType])


    const navigate = useMemo(() => {
        if (props.mzNavigate) {
            return (type: NavigationType, params?: Record<string, any>) => { props.mzNavigate(getNavPathFromType(type, params)) }
        }
        return () => console.warn('MZ Navigation function not implemented')
    }, [props.mzNavigate, getNavPathFromType])

    const getImageURL = useMemo(() => (
        (name: string) => {
            if (name?.startsWith('http') || name?.startsWith('blob') || name?.startsWith('//')) return name;
            const fileNameArray = name?.split('/');
            if(fileNameArray && fileNameArray?.length >= 0){
                const fileName = fileNameArray[fileNameArray.length - 1];
                if(fileName.startsWith('shared_')) {
                    return `${props.imagePathURL?.shared}/${name}`
                }
                if(fileName.startsWith('tenant_')) {
                    return `${props.imagePathURL?.tenant}/${name}`
                }
            }
            return `${props.imagePathURL.default}/${name}`
        }
    ), [props.imagePathURL])


    return (
        <JCommonContext.Provider value={{
            navigate,
            setLoading: props.setLoading,
            getImageURL,
            walletData: props.walletData || []
        }}>
            {props.children}
        </JCommonContext.Provider>
    )
}

export const useJCommonContext = () => useContext(JCommonContext)